
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { uploadFile, comment } from '@/services/http';

@Component({
  components: {
    Header,
    Footer
  }
})
export default class extends Vue {
  isloading: boolean = false; // 图片上传

  details: any = ''; // 订单详情信息

  maxpic: boolean = false; // 是否上传到最大数量

  imgids: string = ''; // 上传图片id

  showText: any[] = ['非常差', '差', '一般', '好', '非常好']; // 星级对应文字描述

  dialogVisible: boolean = false;

  num: number = 3;

  timer: any = '';

  private created() {
    const commentDetails: any = sessionStorage.getItem('commentDetails');
    const details: any[] = commentDetails ? JSON.parse(commentDetails) : [];
    this.details = details.map((item: any) => {
      const data: any = {};
      data.orderNo = item.orderNo;
      data.orderDetailId = item.id;
      data.productName = item.productName;
      data.sourceUrl = item.mallImage.sourceUrl;
      data.starLevel = 5;
      data.content = '';
      data.fileList = [];
      data.imgids = '';
      return data;
    });
  }

  private uploadClick(e: any) {
    e.currentTarget.querySelector('input').click();
  }

  // 上传图片
  private async uploadpic(event: any, index: number) {
    this.isloading = true;
    const file = [...event.target.files];
    if (file.length > 0 && (file[0].size / 1024) > 2048) {
      this.$message.warning('每张不超过2m，支持jpg、png');
      this.isloading = false;
      return;
    }
    if (this.details[index].fileList.length < 3) {
      const uploadlength = 3 - this.details[index].fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.details[index].fileList = [...this.details[index].fileList, ...res.data.data.slice(0, uploadlength)];
        if (this.details[index].fileList.length === 3) {
          this.maxpic = true;
        }
        this.details[index].imgids = this.details[index].fileList.map((e: any) => e.id).join(',');
      } else {
        this.$message.error(res.data.message);
      }
      this.isloading = false;
    }
  }

  // 删除图片
  private removefile(index: number, idx: number) {
    this.details[index].fileList.splice(idx, 1);
    this.details[index].imgids = this.details[index].fileList.map((e: any) => e.id).join(',');
    this.maxpic = false;
  }

  // 发表评价
  private async addEvaluate() {
    const evaluateJsonArr: any[] = [];
    this.details.forEach((item: any) => {
      const obj: any = {};
      obj.orderDetailId = item.orderDetailId;
      obj.starLevel = item.starLevel;
      obj.content = item.content;
      obj.imageIds = item.fileList.length === 0 ? '' : item.imgids;
      evaluateJsonArr.push(obj);
    });
    const res: any = await comment({
      orderNo: this.details[0].orderNo,
      evaluateJsonArr: JSON.stringify(evaluateJsonArr)
    });
    if (res.data && res.data.code === 100) {
      this.dialogVisible = true;
      this.timer = setInterval(() => {
        if (this.num === 1) {
          this.dialogVisible = false;
          clearInterval(this.timer);
          this.$router.push('/evaluation-list');
          return;
        }
        this.num -= 1;
      }, 1000);
      sessionStorage.removeItem('commentDetails');
    } else {
      this.$message.error(res.data.message);
    }
  }

  // 关闭成功发表窗口回调
  private closeDialog() {
    clearInterval(this.timer);
    this.$router.push('/evaluation-list');
  }
}
